import {CSSProperties, HTMLProps, ReactNode, useCallback, useMemo} from 'react';

export type ClickableHandler = (e: React.KeyboardEvent<HTMLDivElement>|React.MouseEvent<HTMLDivElement>) => void;

const Clickable = ({ children, style, onClick, className, disabled, onContextMenu, onPointerOver, onPointerOut, link, ariaLabel, role, divProps }: ClickableProps) => {
  // eslint-disable-next-line
  const defaultRole = useMemo(() => {
    if (disabled) {
      return '';
    }
    if (link) {
      return 'link';
    }
    return 'button';
  }, [disabled, link]);

  const finalOnClick: ClickableHandler = useCallback(e => {
    e.preventDefault()
    onClick(e);
  }, [onClick])

  return (
    <div
      tabIndex={disabled ? undefined : 0}
      className={`clickable ${className}`}
      onClick={!disabled ? finalOnClick : undefined}
      onContextMenu={onContextMenu}
      style={style}
      aria-label={ariaLabel}
      aria-disabled={disabled}
      onKeyDown={event => {
        if (event.key === 'Enter' && !disabled) {
          finalOnClick(event);
        }
      }}
      onPointerOver={onPointerOver}
      onPointerOut={onPointerOut}
      role={role || defaultRole}
      {...(divProps || {})}
    >
      {children}
    </div>
  );
};

interface ClickableProps {
  children: ReactNode,
  ariaLabel: string,
  link?: boolean,
  disabled?: boolean,
  onClick: ClickableHandler,
  onContextMenu?: (event: React.MouseEvent<HTMLDivElement>) => void,
  onPointerOver?: (event: React.MouseEvent<HTMLDivElement>) => void,
  onPointerOut?: (event: React.MouseEvent<HTMLDivElement>) => void,
  style?: CSSProperties,
  divProps?: Partial<HTMLProps<HTMLDivElement>>,
  className?: string,
  role?: string
}

export default Clickable;
